import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/generic_person.png'


const _withScopeId = n => (_pushScopeId("data-v-466b0d73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "member-node-container" }
const _hoisted_2 = {
  key: 0,
  class: "vertical-bar top"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = { class: "id-text" }
const _hoisted_5 = {
  key: 0,
  class: "amount-due"
}
const _hoisted_6 = { class: "amount-due-quantity" }
const _hoisted_7 = {
  key: 1,
  class: "vertical-bar bottom"
}


import { useStore } from "vuex";

import Person from "@/bll/models/Person.mjs";
import utils from "@/bll/utils.mjs";

interface Props {
  member: Person;
  displayTopBar: boolean;
  displayBottomBar: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberNode',
  props: {
    member: {},
    displayTopBar: { type: Boolean },
    displayBottomBar: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const roundToTwoDecimals = utils.roundToTwoDecimals;


const store = useStore();

function getPercentage(): number {
  return roundToTwoDecimals(
    (props.member.amountDue / store.state.estateAmount) * 100
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.displayTopBar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["node-container", _ctx.member.alive ? 'alive' : 'deceased'])
    }, [
      _hoisted_3,
      _createElementVNode("p", null, _toDisplayString(_ctx.member.name), 1),
      _createElementVNode("p", _hoisted_4, "ID: " + _toDisplayString(_ctx.member.uuid), 1),
      (_ctx.member.alive)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
            _createTextVNode(" Amount Due: "),
            _createElementVNode("span", _hoisted_6, _toDisplayString(getPercentage()) + "%", 1)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.displayBottomBar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7))
      : _createCommentVNode("", true)
  ]))
}
}

})